export const CTA_SECTION_ID = 'page-cta-section-aside';
export const CTA_SECTION_ID_MAIN = 'page-cta-section-main';
